import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

// components
import Btn from '../../components/Btn';

// actions
import { addPlacesField } from '../../reducers/Places/actions';

const AddStopBtnPropTypes = {
  directionsLoaded: PropTypes.bool.isRequired, // If the directions have successfully returned from API
  dispatchAddPlacesField: PropTypes.func.isRequired, // Adds a new Places field
  label: PropTypes.string.isRequired, // Button label from AEM
  fieldsLength: PropTypes.number.isRequired, // Number of places/fields in a users trip
  isMobile: PropTypes.bool.isRequired, // If the user is on a mobile device
};

const AddStopBtnDefaultProps = {};

class AddStopBtn extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { dispatchAddPlacesField } = this.props;
    // add a new blank field
    dispatchAddPlacesField();
  }

  render() {
    // eslint-disable-next-line object-curly-newline
    const { directionsLoaded, label, isMobile, fieldsLength } = this.props;

    if (!directionsLoaded) {
      return (
        <Btn
          styles={classNames('add-stop-btn', {
            hidden:
              // eslint-disable-next-line operator-linebreak
              (isMobile && fieldsLength >= 3) ||
              (!isMobile && fieldsLength >= 5),
          })}
          handleClick={this.handleClick}
        >
          {label}
          <i className="tsla-icon-plus--circle" />
        </Btn>
      );
    }

    return null;
  }
}

AddStopBtn.propTypes = AddStopBtnPropTypes;

AddStopBtn.defaultProps = AddStopBtnDefaultProps;

const mapStateToProps = state => ({
  directionsLoaded: state.Directions.directionsLoaded,
  label: state.AddStopBtn.label,
  fieldsLength: state.Places.fieldsLength,
  isMobile: state.App.isMobile,
});

const mapDispatchToProps = dispatch => ({
  dispatchAddPlacesField: () => {
    dispatch(addPlacesField());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddStopBtn);
